import {
  LOAD_CHECKOUT_DATA,
  LOAD_CHECKOUT_DATA_SUCCESS,
  LOAD_SOLD_TO_DETAILS_SUCCESS,
  LOAD_CHECKOUT_FAILURE,
  LOAD_CREDIT_CARDS_DATA,
  LOAD_CREDIT_CARDS_DATA_SUCCESS,
  LOAD_CREDIT_CARDS_FAILURE,
  ADD_ADDRESS,
  ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_FAILURE,
  PLACE_ORDER,
  ADD_CREDITCARD,
  ADD_CREDITCARD_SUCCESS,
  ADD_CREDITCARD_FAILURE,
  REVIEW_ORDER,
  REMOVE_WHOLE_CART_SUCCESS,
  REMOVE_WHOLE_CART_FAILURE,
  LOAD_CHECKOUT_USER_DATA_SUCCESS,
  LOAD_QUOTE_DETAILS_DATA,
  QUOTE_ORDER_MERGE_ADDRESS,
  CART_TO_ORDER_ANALYTICS,
  QUOTE_TO_ORDER_ANALYTICS,
  CONTINUE_TO_PAYMENT,
  RETRIEVE_SETUP_INTENT_PAYMENT_ID,
  RETRIEVE_SETUP_INTENT_PAYMENT_ID_SUCCESS,
  RETRIEVE_SETUP_INTENT_PAYMENT_ID_FAILURE,
  RETRIEVE_PAYMENT_TOKEN_SUCCESS,
  RETRIEVE_PAYMENT_TOKEN_FAILURE,
  RETRIEVE_PAYMENT_TOKEN_UPDATE,
  SET_REFRESH_FLAG,
  SET_COMPARE_FLAG,
  SET_CHECK_COMPLETION,
  SET_IS_ORDER_CALLED,
  SET_IS_SOLD_TO_CHANGES_LOADED,
} from './Checkout.constants';

export const loadCheckoutData = data => ({
  type: LOAD_CHECKOUT_DATA,
  data,
});

export const loadCheckoutDataSuccess = data => ({
  type: LOAD_CHECKOUT_DATA_SUCCESS,
  data,
});

export const loadSoldToDetailsSuccess = data => ({
  type: LOAD_SOLD_TO_DETAILS_SUCCESS,
  data,
});

export const loadUserDataSuccess = data => ({
  type: LOAD_CHECKOUT_USER_DATA_SUCCESS,
  data,
});

export const loadCheckoutFailure = error => ({
  type: LOAD_CHECKOUT_FAILURE,
  error,
});

export const loadCreditCardsData = () => ({
  type: LOAD_CREDIT_CARDS_DATA,
});

export const loadCreditCardsDataSuccess = data => ({
  type: LOAD_CREDIT_CARDS_DATA_SUCCESS,
  data,
});

export const loadCreditCardsFailure = error => ({
  type: LOAD_CREDIT_CARDS_FAILURE,
  error,
});

export const addAddress = (
  data,
  onSubmitSuccess,
  setSelectedAddress,
  isQuoteToOrder,
  validateAddressForTax,
  setCallOrderSimulate
) => ({
  type: ADD_ADDRESS,
  data,
  onSubmitSuccess,
  setSelectedAddress,
  isQuoteToOrder,
  validateAddressForTax,
  setCallOrderSimulate,
});

export const addAddressSuccess = data => ({
  type: ADD_ADDRESS_SUCCESS,
  data,
});

export const addAddressFailure = data => ({
  type: ADD_ADDRESS_FAILURE,
  data,
});

export const placeOrder = data => ({
  type: PLACE_ORDER,
  data,
});

export const addCreditCard = (formData, onSubmitSuccess, setSelectedRecord) => ({
  type: ADD_CREDITCARD,
  formData,
  onSubmitSuccess,
  setSelectedRecord,
});

export const addCreditCardSuccess = data => ({
  type: ADD_CREDITCARD_SUCCESS,
  data,
});

export const addCreditCardFailure = data => ({
  type: ADD_CREDITCARD_FAILURE,
  data,
});
export const retrieveSetupIntentPaymentId = data => ({
  type: RETRIEVE_SETUP_INTENT_PAYMENT_ID,
  data,
});
export const retrieveSetupIntentPaymentIdSuccess = data => ({
  type: RETRIEVE_SETUP_INTENT_PAYMENT_ID_SUCCESS,
  data,
});

export const retrieveSetupIntentPaymentIdFailure = data => ({
  type: RETRIEVE_SETUP_INTENT_PAYMENT_ID_FAILURE,
  data,
});

export const retrievePaymentTokenSuccess = data => ({
  type: RETRIEVE_PAYMENT_TOKEN_SUCCESS,
  data,
});

export const retrievePaymentTokenUpdate = data => ({
  type: RETRIEVE_PAYMENT_TOKEN_UPDATE,
  data,
});

export const retrievePaymentTokenFailure = data => ({
  type: RETRIEVE_PAYMENT_TOKEN_FAILURE,
  data,
});

export const reviewOrder = data => ({
  type: REVIEW_ORDER,
  data,
});

export const removeWholeCartFailure = error => ({
  type: REMOVE_WHOLE_CART_FAILURE,
  error,
});

export const removeWholeCartSuccess = data => ({
  type: REMOVE_WHOLE_CART_SUCCESS,
  data,
});

export const loadQuoteDetailsData = () => ({
  type: LOAD_QUOTE_DETAILS_DATA,
});

export const quoteToOrderMergeAddress = addressType => ({
  type: QUOTE_ORDER_MERGE_ADDRESS,
  addressType,
});

export const continueToPaymentClick = () => ({
  type: CONTINUE_TO_PAYMENT,
});

export const cartToOrderAnalytics = data => ({ type: CART_TO_ORDER_ANALYTICS, data });

export const quoteToOrderAnalytics = data => ({ type: QUOTE_TO_ORDER_ANALYTICS, data });

export const setRefreshFlag = payload => ({
  type: SET_REFRESH_FLAG,
  payload,
});

export const setCompareFlag = payload => ({
  type: SET_COMPARE_FLAG,
  payload,
});

export const setCheckCompletion = payload => ({
  type: SET_CHECK_COMPLETION,
  payload,
});

export const setIsOrderCalled = payload => ({
  type: SET_IS_ORDER_CALLED,
  payload,
});

export const setIsSoldToChangesLoaded = payload => ({
  type: SET_IS_SOLD_TO_CHANGES_LOADED,
  payload,
});

export default [loadQuoteDetailsData, loadCheckoutData, loadCreditCardsData];
